import ThemeConfig from '../theme-config';

const themeConfig: ThemeConfig = {
  data: {
    url: 'https://hephata-bewerber.dvinci-hr.com/jobPublication/list.json',
    language: 'de',
  },
  styles: {
    fontSize: '16px',
    textColor: '#333333',
    brandColor: '#8c0679',
    fontFamily: 'Frutiger-LT, Arial, sans-serif',
    borderRadius: '5px',
    headlineStyle: {
      fontSize: '28px',
      color: '#8c0679',
      fontWeight: 300,
    },
    labelStyle: {
      fontSize: '16px',
      color: '#333333',
      fontWeight: 800,
    },
  },
  cardContent: {
    contractPeriod: { enabled: true },
    earliestEntryDate: { enabled: true },
  },
  filters: {
    keywords: { enabled: true, order: 4 },
    targetGroups: { order: 3 },
    locations: { order: 2 },
    maps: { enabled: true },
  },
  api: {
    maps: {
      apiKey: 'AIzaSyD6_LTFtVFX1NW6BQ4KSPrPGN8bwnmgklg',
      requireConsent: true,
      defaultCenter: { lat: 52.6376, lng: -1.135_171 },
    },
  },
  i18n: {
    messages: {
      de: {},
      en: {},
    },
  },
  ui: {
    theme: undefined,
    showIcons: true,
  },
};

export default themeConfig;
